import { authService } from './../../shared/services/auth.service';
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    // ValidationObserver,
    // ValidationProvider
  }
})
export default class Login extends Vue {

  public created(){
    //console.log("Login created");
  }

  public mounted() {
      authService.login();
  }
  // appTitle = process.env.VUE_APP_TITLE;
  // login: ItiLogin = new ItiLogin();
  // show2: Boolean = true;

  // async submit() {
  //   const loginOk = await authorizationService.login(this.login);
  //   this.loginResult(loginOk);
  // }

  // loginResult(loginOk: boolean) {
  //   if (loginOk) {
  //     setTimeout(() => this.routeToMain(), 250);
  //   } else {
  //     itiMessageService.toast('Usuario o Clave incorrectos', itiMessageService.TypeError);
  //   }
  // }

  // routeToMain() {
  //   this.$router.push('/');
  // }

}
